import { ICompanyHeaderDisplaySettingsDTO } from '@user/store/companyHeaderDisplaySettings/typings'
import { ICompanySetup } from '@user/store/companySetup/typings'

import { ICompanyIdentifier } from './typings'

const clean = (value?: string | null) => (value ?? '').trim()

const join = (parts: (string | false)[], sep: string) =>
  parts.filter((p): p is string => !!p).join(sep)

/** True when at least one of the five company header fields is enabled. */
export const hasAnyEnabledField = (s: ICompanyHeaderDisplaySettingsDTO) =>
  s.showCompanyName ||
  s.showAddress ||
  s.showCity ||
  s.showState ||
  s.showPostalCode

/**
 * Builds the "Company Name – Address, City, State Postal Code" string from the
 * enabled fields only, skipping blank values so no placeholder or double
 * separator appears. Returns null when nothing is left to show.
 */
export const buildCompanyIdentifier = (
  settings: ICompanyHeaderDisplaySettingsDTO,
  company: ICompanySetup,
): ICompanyIdentifier | null => {
  const { address } = company
  const street = join([clean(address?.address), clean(address?.address2)], ' ')
  const stateZip = join(
    [
      settings.showState && clean(address?.state),
      settings.showPostalCode && clean(address?.postalCode),
    ],
    ' ',
  )
  const location = join(
    [
      settings.showAddress && street,
      settings.showCity && clean(address?.city),
      stateZip,
    ],
    ', ',
  )
  const name = (settings.showCompanyName && clean(company.name)) || null
  const full = join([name ?? false, location], ' – ')
  return full ? { name, full } : null
}
